var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnerMexc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 31,
    viewBox: "0 0 206 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1952_1704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0374 21.8009L38.3865 3.54604C36.062 -0.255631 30.3373 -0.28988 28.0822 3.7173L16.9106 22.6914C14.829 26.1848 17.3963 30.5345 21.5943 30.5345H44.0415C48.2396 30.5687 51.3968 26.0479 49.0374 21.8009Z",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6679 23.2407L33.0087 22.1104C32.3842 21.0487 31.0311 18.7883 31.0311 18.7883L22.0106 3.3076C19.6861 -0.117335 14.135 -0.425584 11.8105 3.92409L1.29817 21.8707C-0.887575 25.6381 1.7145 30.5358 6.43294 30.57H28.7413H38.2475H43.9028C38.1434 30.6043 36.3048 27.6246 33.6679 23.2407Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.668 23.1722L33.0088 22.042C32.3843 20.9803 31.0313 18.7198 31.0313 18.7198L25.2026 8.58203L16.8413 22.6927C14.7596 26.1862 17.327 30.5358 21.525 30.5358H28.7067H38.213H43.9029C38.1089 30.5016 36.3048 27.5904 33.668 23.1722Z",
    fill: "url(#paint0_linear_1952_1704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.701 8.52767C189.262 7.0892 192.003 6.4042 195.993 6.4042H205.326V1.16406H194.293C191.656 1.16406 189.436 1.43807 187.701 1.98605C186.001 2.53404 184.509 3.39027 183.226 4.58899C181.872 5.89047 180.797 7.50017 180.034 9.41813C179.271 11.3703 178.889 13.4938 178.889 15.72C178.889 17.8435 179.271 19.8984 180.034 21.7822C180.797 23.6659 181.872 25.3098 183.226 26.6113C184.475 27.81 185.966 28.6662 187.632 29.2142C189.332 29.7622 191.587 30.0362 194.293 30.0362H205.326V24.8646H195.993C193.877 24.8646 192.42 24.7961 191.587 24.6248C190.72 24.4536 189.922 24.1796 189.262 23.7686C187.944 22.9466 186.938 21.8849 186.279 20.5492C185.654 19.2477 185.342 17.6037 185.342 15.6858C185.342 12.3978 186.14 9.96614 187.701 8.52767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.482 30.1056H132.503V25.0367H112.831V17.8101H130.005V13.0152H112.831V6.30236H132.503V1.19922H106.482V30.1056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.99 1.19922L151.168 15.6524L138.99 30.1056H146.866L156.476 18.6664V12.6727L146.866 1.19922H138.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.55 1.19922L158.94 12.6727V18.6664L168.55 30.1056H176.426L164.213 15.6524L176.426 1.19922H168.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9817 15.4469L69.2897 1.19922H63.2529V30.1056H69.6019V10.8233L79.7327 22.8106H82.1958L92.3266 10.7206V30.1056H98.6756V1.19922H92.7084L80.9817 15.4469Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1952_1704",
    x1: 13.8571,
    y1: 16.2976,
    x2: 39.6949,
    y2: 25.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003087"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1952_1704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 31,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerMexc);
export default __webpack_public_path__ + "static/media/partner-mexc.9dd30029524705e715975a2ab4f5c3f2.svg";
export { ForwardRef as ReactComponent };